<script>
  // Import the getContext function from svelte
  import { getContext, onMount, createEventDispatcher } from 'svelte';

  // Access the context using the 'LayerCake' keyword
  // Grab some helpful functions
  const { data, xGet, yGet, xScale, yScale, padding } = getContext('LayerCake');

  export let gate;
  // Customizable defaults
  let g;
  let width;
  let dispatch = createEventDispatcher();
  let points;
  let line;
  let fill;
  export let active = false;
  export let selected = false;
  let live = null;
  let yrange = $yScale.domain()


  function oMousePosSVG(e) {
    let svg = g.closest("svg");
    var p = svg.createSVGPoint();
    p.x = e.x;
    p.y = e.y;
    var ctm = svg.getScreenCTM().inverse();
    var p =  p.matrixTransform(ctm);
    return p;
  }

  function move_gate(e){
    if(live !== null){
      if(live === "all"){
        var x = e.movementX;
        var y = e.movementY;
        for(var i = 0; i < gate.length; i++){
          gate[i].x = $xScale.invert($xScale(gate[i].x) + x);
        }
      }
      else{
        var p = oMousePosSVG({x: e.clientX-$padding.left, y: e.clientY-$padding.top});
        gate[live].x = $xScale.invert(p.x);

      }

      gate = gate;
    }
  }


  function mousedown(e){
    if (!g.contains(e.target)) return;
    if(e.target.nodeName === "line"){
      live = parseInt(e.target.getAttribute("index"))
    }
    else if(e.target.nodeName === "polygon"){
      live = "all";
    }
  }

  function keypress(e){
    if(selected){
      switch(e.which){
        case 37:
          gate = gate.map((g)=>{
            g.x = g.x - 0.01;
            return g;
          })
          break;
        case 39:
          gate = gate.map((g)=>{
            g.x = g.x + 0.01;
            return g;
          })
          break;
        case 107:
        case 187:
          gate[0].x -= 0.01;
          gate[1].x += 0.01;

          break;
        case 109:
        case 189:
          gate[0].x += 0.01;
          gate[1].x -= 0.01;
          break;
      }
    }
  }

  function mouseup(e){
    live=null;
    if (!g.contains(e.target)) return;
    if(e.target.nodeName === "line" || e.target.nodeName === "polygon"){
      selected = !selected;
    }
  }

  $: points = gate.map((g)=>{
    return {"x": $xScale(g.x), "y": $yScale(g.y),  "y1": $yScale(g.y+0.1), "y2": $yScale(g.y-0.1)}
  });

  $: line = points.map((p)=>{
    return [p.x, p.y].join(",");
  }).join(" ");

  $: width = active? 3: 2;
  $: fill = active || selected? "#b15928": "#ff7f00";

  onMount(()=>{
    let svg = g.closest("svg");
    // svg.addEventListener("mousedown", start_draw);
    svg.addEventListener("mousemove", move_gate);
    svg.addEventListener("mouseup", mouseup);
    window.addEventListener("keydown", keypress)
  })

</script>

<g on:mousedown={mousedown} on:mouseover={()=>active=true} on:mouseout={()=>active=false} bind:this={g}>
  {#if selected || active || live}
    {#each points as p, i}
      <line index={i} x1='{ p.x }' x2='{ p.x }' y1='{ $yScale(yrange[0]) }' y2='{ $yScale(yrange[1]) }' fill={fill} stroke={fill} stroke-width={width} stroke-dasharray="3,3"></line>
    {/each}
  {/if}
  <polygon points="{line}" stroke={fill} class="gate"></polygon>
  {#each points as p, i}
    <line index={i} x1='{ p.x }' x2='{ p.x }' y1='{ p.y1 }' y2='{ p.y2 }' fill={fill} stroke={fill} stroke-width={width}></line>
    <line index={i} x1='{ p.x }' x2='{ p.x }' y1='{ $yScale(yrange[0]) }' y2='{ $yScale(yrange[1]) }' class="handle"></line>
  {/each}
</g>

<style>
  .gate{
    fill: transparent;
    stroke-width: 2;
  }

  .handle{
    stroke: transparent;
    fill: transparent;
    stroke-width: 8;
    cursor: move;
  }

</style>
